'use client';

import { useCallback, useEffect, useState, ReactNode } from 'react';
import s from './Modal.module.scss';

interface ModalBackdropProps {
  children: ReactNode;
  onClose: () => void;
}

export default function ModalBackdrop({
  children,
  onClose,
}: ModalBackdropProps) {
  const [active, setActive] = useState(false);

  const handleCloseModal = useCallback(
    (e: React.MouseEvent | KeyboardEvent) => {
      if (
        (e.type === 'click' && (e.target as HTMLElement) === e.currentTarget) ||
        (e.type === 'keydown' && (e as KeyboardEvent).key === 'Escape')
      ) {
        setActive(false);
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    // Small delay for animation
    const id = setTimeout(() => {
      setActive(true);
    }, 0);

    return () => clearTimeout(id);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => handleCloseModal(e);

    window.addEventListener('keydown', handleKeyDown);

    // Disable scroll
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      // Restore scroll
      document.body.removeAttribute('style');
    };
  }, [handleCloseModal]);

  return (
    <div
      className={`${s.overlay} ${active ? s.active : ''}`}
      onClick={handleCloseModal}
    >
      {children}
    </div>
  );
}
